module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "myform",
    attrs: {
      "model": _vm.formData,
      "label-width": _vm.config.base.labelWidth,
      "rules": _vm.config.rules
    }
  }, [_vm._l((_vm.config.item), function(row) {
    return _c('el-row', _vm._l((row), function(item) {
      return _c('el-col', {
        attrs: {
          "span": item.span == undefined ? 24 : item.span
        }
      }, [_c('el-form-item', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item.show == undefined ? true : _vm.formData[item.show.field] == item.show.val),
          expression: "item.show == undefined ? true : formData[item.show.field] == item.show.val"
        }],
        attrs: {
          "label": item.title,
          "prop": item.id
        }
      }, [(item.type == 'input') ? _c('el-input', {
        attrs: {
          "icon": item.config !== undefined && item.config.icon !== undefined ? item.config.icon : null
        },
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }, [(item.config !== undefined && item.config.prepend !== undefined) ? _c('template', {
        slot: "prepend"
      }, [_vm._v(_vm._s(item.config.prepend))]) : _vm._e(), _vm._v(" "), (item.config !== undefined && item.config.append !== undefined) ? _c('template', {
        slot: "append"
      }, [_vm._v(_vm._s(item.config.append))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (item.type == 'number') ? _c('el-input-number', {
        attrs: {
          "min": item.config.min,
          "max": item.config.max,
          "step": item.config.step
        },
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }) : _vm._e(), _vm._v(" "), (item.type == 'rate') ? _c('el-rate', {
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }) : _vm._e(), _vm._v(" "), (item.type == 'upload') ? _c('el-upload', {
        staticClass: "avatar-uploader",
        attrs: {
          "action": item.config.action,
          "show-file-list": false,
          "on-success": _vm.handleAvatarSuccess,
          "before-upload": _vm.beforeAvatarUpload
        }
      }, [(_vm.formData.fitdata) ? _c('img', {
        staticClass: "avatar",
        attrs: {
          "src": 'http://www.888jigong.com/upload/orderimg/' + _vm.formData.fitdata
        }
      }) : _c('i', {
        staticClass: "el-icon-plus avatar-uploader-icon"
      })]) : _vm._e(), _vm._v(" "), (item.type == 'select') ? _c('el-select', {
        attrs: {
          "multiple": item.config == undefined || item.config.multiple == undefined ? false : item.config.multiple,
          "placeholder": item.placeholder
        },
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }, _vm._l((item.data), function(it) {
        return _c('el-option', {
          attrs: {
            "label": it.text,
            "value": it.id
          }
        })
      })) : _vm._e(), _vm._v(" "), (item.type == 'select_remote') ? _c('xselect-remote', {
        attrs: {
          "url": item.config.url,
          "text-field": item.config.textField,
          "value-field": item.config.valueField,
          "default-item": _vm.formData[item.id],
          "placeholder": item.placeholder
        },
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }) : _vm._e(), _vm._v(" "), (item.type == 'check') ? _c('el-checkbox-group', {
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }, _vm._l((item.data), function(it) {
        return _c('el-checkbox', {
          attrs: {
            "label": it.id
          }
        }, [_vm._v(_vm._s(it.text))])
      })) : _vm._e(), _vm._v(" "), (item.type == 'radio') ? _c('el-radio-group', {
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }, [_vm._l((item.data), function(it) {
        return (item.config.type == undefined) ? _c('el-radio', {
          attrs: {
            "label": it.id
          }
        }, [_vm._v(_vm._s(it.text))]) : _vm._e()
      }), _vm._v(" "), _vm._l((item.data), function(it) {
        return (item.config.type == 'btn') ? _c('el-radio-button', {
          attrs: {
            "label": it.id
          }
        }, [_vm._v(_vm._s(it.text))]) : _vm._e()
      })], 2) : _vm._e(), _vm._v(" "), (item.type == 'switch') ? _c('el-switch', {
        attrs: {
          "on-text": "",
          "off-text": ""
        },
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }) : _vm._e(), _vm._v(" "), (item.type == 'cascader') ? _c('xcascader', {
        attrs: {
          "url": item.config.url,
          "value-field": item.config.valueField,
          "text-field": item.config.textField,
          "placeholder": item.placeholder
        },
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }) : _vm._e(), _vm._v(" "), (item.type == 'date') ? _c('el-date-picker', {
        attrs: {
          "type": item.config.type,
          "placeholder": "选择日期"
        },
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }) : _vm._e(), _vm._v(" "), (item.type == 'textarea') ? _c('el-input', {
        attrs: {
          "autosize": item.config.autosize,
          "rows": item.config.rows,
          "type": "textarea"
        },
        model: {
          value: (_vm.formData[item.id]),
          callback: function($$v) {
            _vm.$set(_vm.formData, item.id, $$v)
          },
          expression: "formData[item.id]"
        }
      }) : _vm._e()], 1)], 1)
    }))
  }), _vm._v(" "), _c('el-form-item', [(_vm.config.submit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.config.submit.btnText))]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-260b53a4!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/xelement/form.vue
// module id = 214
// module chunks = 2